import { DecretTertiaireDiagnostic } from '../../../components/tools/DecretTertiaireDiagnostic';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('tertiaire', 'decret-tertiaire')!;

export default function TertiaireDecretTertiairePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/tertiaire"
        backLabel="Espace tertiaire"
        duration="3 min"
      >
        <DecretTertiaireDiagnostic lockedAudience="tertiaire" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace tertiaire', url: 'https://solutionecofrance.fr/tertiaire' },
          { name: 'Décret Tertiaire', url: 'https://solutionecofrance.fr/tertiaire/decret-tertiaire' },
        ]}
      />
    </>
  );
}
